import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Système multilingue global. FR = langue par défaut. Le sélecteur d'en-tête (LanguageToggle)
// appelle i18n.changeLanguage via LanguageContext.
const stored = (() => { try { return localStorage.getItem("bizarre_lang"); } catch (_) { return null; } })();

const resources = {
  fr: { translation: {
    brand: { home: "La maison de la marque", version: "BIZARRE AI · v1.0.0 (bêta)", menu: "Menu" },
    common: {
      open: "Ouvrir", openLink: "Ouvrir", logout: "Déconnexion", profile: "Profil",
      goPremium: "Passer Premium", admin: "Admin", loading: "EN COURS…",
    },
    nav: {
      home: "Accueil", citation: "Citation du jour", situation: "Je vis une situation",
      reply: "Répondre", analyze: "Analyser", create: "Créer", debate: "Débat", coach: "Coach",
      afromap: "Carte Afro", communitySpace: "Espace Communauté", youth: "Espace Jeunes",
      parents: "Espace Parents", rights: "Vos droits", letters: "Courriers", news: "Actualités",
      library: "Base de connaissances", authors: "Auteurs & sources", bookshelf: "Bibliothèque",
      professionals: "Professionnels", community: "Communauté", ideas: "Idées", whatsnew: "Nouveautés",
      feedback: "Votre avis", history: "Historique", dashboard: "Tableau de bord", about: "La maison BIZARRE",
      discover: "Découvre", help: "Aide", me: "Moi", rightsShort: "Droits", profileShort: "Profil",
      resources: "Ressources",
    },
    home: {
      heroTitle1: "On vous attaque.", heroTitle2: "Répondez mieux.",
      heroSub1: "Commentaires racistes. Discriminations. Harcèlement. Injustices.",
      heroSub2: "Collez le message. BIZARRE AI fait le reste.",
      placeholder: "Collez un commentaire, un message ou une situation…",
      replyNow: "RÉPONDRE MAINTENANT", analyzeNow: "ANALYSER MAINTENANT",
      step1: "Collez", step2: "L'IA répond", step3: "Copiez & publiez",
      writing: "BIZARRE AI rédige votre réponse…",
      writingSub: "Réponse factuelle, sourcée et argumentée. Quelques secondes.",
      resetAnother: "↺ Analyser un autre commentaire",
      statsTitle: "BIZARRE AI en chiffres", statReplies: "Réponses générées",
      statAnalyses: "Analyses réalisées", statUsers: "Utilisateurs",
      whatToDo: "Que voulez-vous faire ?",
      actions: {
        repondre: { title: "Répondre", desc: "Une réponse claire et argumentée à toute attaque." },
        analyser: { title: "Analyser", desc: "Comprendre une situation et savoir quoi faire." },
        droits: { title: "Connaître mes droits", desc: "Vos recours et des courriers prêts à l'emploi." },
        bibliotheque: { title: "Bibliothèque", desc: "Livres et auteurs afro-descendants sélectionnés." },
        creer: { title: "Créer du contenu", desc: "Hooks, scripts et idées qui marquent." },
        communaute: { title: "Communauté", desc: "Échanger, s'entraider et partager." },
      },
      exampleTitle: "Un exemple concret", exampleComment: "Le commentaire",
      exampleReplyLabel: "Réponse BIZARRE AI", tryExample: "ESSAYER CET EXEMPLE",
      demoComment: "Retourne dans ton pays.",
      demoReply: "Je suis chez moi, et la citoyenneté ne se mesure pas à la couleur de peau. Votre phrase n'est pas un argument : c'est un préjugé que la loi (art. 33 de la loi de 1881) sanctionne comme injure à caractère raciste.",
      soon: "Bientôt · Communauté BIZARRE AI",
      communityTitle1: "Le premier réseau social où l'IA répond", communityTitle2: "à votre place",
      communityDesc: "Depuis n'importe quelle publication, un clic suffira : « Répondre avec BIZARRE AI » ou « Analyser avec BIZARRE AI ». C'est la signature de la plateforme.",
      discoverCommunity: "Découvrir la communauté",
      signature: "Des réponses. Des experts. Des livres. Des outils.", signatureGold: "Enfin réunis.",
      signatureSub: "Un univers signé Céleste Créations.",
      teaser: { profiles: "Profils", posts: "Publications", comments: "Commentaires", follows: "Abonnements", groups: "Groupes", messaging: "Messagerie", notifications: "Notifications" },
    },
    child: {
      greetingNamed: "Salut {{name}} !", greeting: "Salut champion !",
      howAreYou: "Comment ça va aujourd'hui ?",
      namePlaceholder: "Écris ton prénom (facultatif)",
      changeName: "Changer mon prénom", addName: "Ajouter mon prénom",
      whatToDo: "Que veux-tu faire ?",
      cards: { hurt: "Quelqu'un m'a blessé", said: "On m'a dit quelque chose", understand: "Je veux comprendre", sorties: "Sorties & activités" },
      tellMe: "Raconte-moi", tellMeSub: "Appuie et parle, je t'écoute.",
      needAdult: "J'ai besoin d'un adulte",
    },
    teen: {
      heroTitle: "On te comprend.\nOn t'équipe.\nÀ toi d'agir.",
      heroSub: "Racisme, harcèlement, discriminations : tu n'es pas seul·e.",
      talkToAI: "Parler à l'IA", analyzeSituation: "Analyser une situation",
      punchline: "Ta voix compte. Utilise-la.", whatToDo: "Que veux-tu faire ?",
      cards: {
        reply: { title: "Répondre", desc: "Trouve les mots justes." },
        analyze: { title: "Analyser", desc: "Comprends ce qui se passe." },
        rights: { title: "Connaître mes droits", desc: "Tes droits, tes recours." },
        create: { title: "Créer du contenu", desc: "Hooks, posts, arguments." },
        library: { title: "Bibliothèque", desc: "Livres, podcasts, vidéos." },
      },
    },
    parent: {
      welcome: "Bienvenue, parent.",
      welcomeSub: "Vous n'êtes pas seul(e) pour protéger et guider votre enfant.",
      talkToAI: "Parler à l'IA", childSituation: "Situation de mon enfant",
      whatToDo: "Que souhaitez-vous faire ?",
      cards: {
        understand: { title: "Comprendre la situation", desc: "Analyser ce que vit votre enfant." },
        rights: { title: "Connaître ses droits", desc: "Les droits de votre enfant et vos recours." },
        act: { title: "Agir et orienter", desc: "Les démarches et les organismes à contacter." },
        resources: { title: "Ressources pour parents", desc: "Conseils, guides et soutien." },
        sorties: { title: "Sorties & activités enfants", desc: "Carte des activités afro & culturelles." },
      },
      guidesTitle: "Guides pratiques",
      guides: {
        listen: { title: "Savoir écouter mon enfant", points: [
          "Choisissez un moment calme et laissez votre enfant raconter à son rythme, sans l'interrompre.",
          "Accueillez ses émotions : « Je te crois, merci de m'en parler. Tu n'y es pour rien. »",
          "Évitez de minimiser (« ce n'est rien ») ou de sur-réagir : restez posé·e et rassurant·e.",
          "Posez des questions ouvertes : que s'est-il passé, quand, qui était là, comment tu te sens ?",
          "Rappelez-lui qu'il peut toujours revenir vous en parler, et qu'il n'est pas seul.",
        ]},
        proof: { title: "Conserver et collecter les preuves", points: [
          "Notez les faits par écrit : dates, heures, lieux, personnes présentes et paroles exactes.",
          "Faites des captures d'écran des messages, commentaires ou publications (avec la date visible).",
          "Conservez les documents utiles : mots, courriers, certificats médicaux, attestations de témoins.",
          "Gardez une copie en lieu sûr et rangez tout par ordre chronologique.",
          "Ces preuves aideront pour un signalement à l'école, une plainte ou un accompagnement juridique.",
        ]},
        steps: { title: "Les démarches selon la situation", points: [
          "À l'école (harcèlement, discrimination) : demandez un rendez-vous écrit avec l'enseignant, le CPE ou la direction, et gardez une trace des échanges.",
          "Si rien ne bouge : saisissez par écrit le chef d'établissement, puis l'inspection académique (rectorat).",
          "Racisme / discrimination : vous pouvez saisir le Défenseur des droits (gratuit) et contacter une association spécialisée.",
          "En cas d'infraction (menaces, violences, propos racistes) : un dépôt de plainte est possible au commissariat ou par courrier au procureur.",
          "Pour être accompagné·e : un·e avocat·e, une association ou un professionnel peut vous guider. Ces informations sont générales et ne remplacent pas un conseil juridique personnalisé.",
        ]},
      },
      recoTitle: "Nos recommandations pour vous accompagner",
      steps: {
        s1: { title: "Écouter et rassurer", desc: "Votre enfant doit se sentir en sécurité." },
        s2: { title: "Collecter des preuves", desc: "Messages, dates, témoins…" },
        s3: { title: "Dialoguer ou signaler", desc: "Parlez aux responsables ou signalez." },
        s4: { title: "Se faire accompagner", desc: "Associations, médiateurs, juridique." },
      },
    },
    privacy: {
      default: "Tes écrits sont privés : visibles seulement par toi, sur ton compte. Les autres utilisateurs ne peuvent pas les voir.",
      kids: "Tu peux regarder les sorties. Pour t'inscrire ou réserver, demande à un adulte : rien ne se fait sans un parent.",
    },
    confidential: {
      badge: "Bêta privée confidentielle", title: "Accès réservé aux bêta-testeurs",
      body: "Cette version de BIZARRE AI est confidentielle et réservée aux personnes invitées. Merci de ne pas diffuser publiquement son contenu, ses captures d'écran ou ses fonctionnalités avant le lancement officiel. Vos retours sont précieux — utilisez le bouton « Signaler un problème ».",
      ack: "J'ai compris, je garde ça confidentiel",
    },
    kids: {
      title: "Sorties & activités", subtitle: "Découvre des activités près de chez toi 🎨🥁📚",
      filters: { all: "Tout", today: "Aujourd'hui", weekend: "Ce week-end", wednesday: "Mercredi", vacances: "Vacances", free: "Gratuit" },
      terr: { metropole: "🇫🇷 France métropolitaine", guadeloupe: "🌴 Guadeloupe", martinique: "🌺 Martinique" },
      allCats: "Toutes catégories", allRegions: "Toutes régions",
      map: "Carte", list: "Liste", free: "Gratuit", paid: "Payant",
      years: "ans", noResults: "Aucune sortie pour ce filtre. Reviens bientôt !",
      listen: "Écoute", stop: "Stop", wantToGo: "Je veux y aller !",
      safety: "Cette sortie doit être organisée avec un adulte. Demande à un parent.",
      wishSent: "✨ Super ! J'envoie ta demande à ton parent.",
      wishNoParent: "Demande à un adulte de lier son compte au tien pour lui envoyer ton envie 💛",
      wishError: "Oups, réessaie dans un instant.", audioUnavailable: "La lecture audio n'est pas disponible ici.",
    },
    pages: {
      reply: { eyebrow: "Répartie", title: "Répondre à un commentaire",
        subtitle: "Collez ou scannez un commentaire, l'IA génère une réponse courte, développée, plusieurs styles et, si le sujet le mérite, des sources et le niveau de confiance.",
        yourComment: "Votre commentaire", closeScan: "Fermer le scan", scanImage: "Scanner une image",
        scanHint: "Importez une capture d'écran ou prenez une photo du commentaire.",
        addImage: "Ajouter une image", analyzing: "Analyse...", takePhoto: "Prendre une photo", chooseGallery: "Choisir dans la galerie",
        placeholder: "Ex : « Retourne dans ton pays. »", placeholderChild: "Ex : « T'as des cheveux bizarres. »",
        generate: "Générer les réponses", spinnerScan: "Détection du texte...", spinnerGen: "Génération en cours...", textDetected: "Texte détecté !" },
      analyze: { eyebrow: "Analyse", title: "Analyse d'une situation",
        subtitle: "Racontez ce qu'il s'est passé. L'IA propose une analyse nuancée, sans conclusions automatiques.",
        placeholder: "Ex : « Mon collègue m'a dit devant tout le monde que… »",
        placeholderChild: "Ex : « Un élève de ma classe s'est moqué de ma peau devant tout le monde. »",
        analyze: "Analyser", spinner: "Analyse en cours...",
        sec_interpretations: "Interprétations possibles", sec_calm: "Répondre avec calme",
        sec_doc: "Documenter les faits", sec_resources: "Ressources utiles",
        premiumHint: "Premium débloque des analyses en nombre bien plus élevé et l'historique complet." },
      rights: { eyebrow: "Vos droits", title: "Connaître vos droits",
        subtitle: "Comprenez vos droits simplement. Des fiches claires, un assistant, et l'IA qui explique la loi en français courant.",
        disclaimer: "Informations juridiques générales, qui ne remplacent pas l'avis d'un avocat.",
        victimCta: "Je pense être victime d'une discrimination",
        victimSub: "Choisissez votre situation et obtenez lois, droits, démarches et délais.",
        smartSearch: "Recherche intelligente",
        searchPlaceholder: "Ex : « Mon employeur me discrimine », « J'ai reçu des insultes racistes »…",
        find: "Trouver", noMatch: "Aucune fiche ne correspond. Essayez l'assistant ci-dessous.",
        situationTitle: "Ma situation est-elle concernée ?",
        situationDesc: "Décrivez ce qu'il vous arrive. L'IA vous indique les droits qui peuvent être concernés et les démarches possibles.",
        situationPlaceholder: "Ex : « Un bar a refusé de me laisser entrer alors que mes amis sont passés… »",
        analyzeMy: "Analyser ma situation", spinner: "Analyse en cours...", seeSheet: "Voir la fiche :",
        sec_rules: "Règles potentiellement applicables", sec_rights: "Droits concernés",
        sec_evidence: "Preuves à conserver", sec_steps: "Démarches possibles", sec_orgs: "Qui contacter",
        loadingSheets: "Chargement des fiches..." },
      letters: { back: "Mes courriers", resultEyebrow: "Courrier", resultTitle: "Relisez et ajustez", recipientPrefix: "Destinataire : ",
        objet: "Objet", corps: "Corps du courrier", copy: "Copier", save: "Enregistrer", pdf: "Télécharger le PDF",
        copied: "Texte copié.", saved: "Courrier enregistré.", pdfError: "Téléchargement impossible.",
        senderWarn1: "Ajoutez vos coordonnées dans ", senderWarnLink: "votre profil", senderWarn2: " pour qu'elles apparaissent automatiquement dans le PDF (nom, adresse, signature).",
        advPreuves: "Preuves à conserver", advEtapes: "Prochaines étapes", advOrgs: "Qui contacter",
        formEyebrow: "Nouveau courrier", formTitle: "Décrivez votre situation", formSub: "Répondez simplement, avec vos mots. BIZARRE AI rédige le courrier pour vous.",
        toWhom: "À qui écrivez-vous ?", chooseRecipient: "— Choisir un destinataire —", orCustom: "… ou saisissez librement (ex : Directeur des ressources humaines)",
        letterType: "Type de courrier", optional: "— Optionnel —", tone: "Ton du courrier",
        generate: "Générer mon courrier", generating: "Rédaction en cours…", spinnerGen: "BIZARRE AI rédige votre courrier…",
        needSituation: "Décrivez d'abord votre situation.", duplicated: "Courrier dupliqué.", removed: "Supprimé.", confirmRemove: "Supprimer ce courrier ?",
        listEyebrow: "Assistant courriers", listTitle: "Générateur de courriers",
        listSub: "Décrivez votre situation, l'IA rédige un courrier clair et professionnel. Modifiable et téléchargeable en PDF.",
        newLetter: "Nouveau courrier", empty: "Aucun courrier pour l'instant. Créez votre premier courrier en quelques minutes.",
        open: "Ouvrir", duplicate: "Dupliquer", remove: "Supprimer", loading: "Chargement..." },
      books: { eyebrow: "Bibliothèque", title: "La vitrine BIZARRE",
        subtitle: "Livres, auteurs et mémoire afro-descendante — une bibliothèque vivante, enrichie régulièrement.",
        all: "Tout", partnerAuthor: "Auteur partenaire", recommended: "Recommandé", nouveautes: "📚 Nouveautés",
        emptyCat: "De nouveaux ouvrages seront bientôt ajoutés dans « {{cat}} ».",
        empty: "De nouveaux ouvrages seront bientôt ajoutés.", loading: "Chargement..." },
      childVoice: { tellMe: "Raconte-moi", tellMeName: "Raconte-moi, {{name}}",
        listening: "Je t'écoute… parle avec tes mots.", pressMic: "Appuie sur le micro et dis ce qui s'est passé.",
        listeningBadge: "● En écoute — appuie pour arrêter", send: "C'est bon, envoie", retry: "Recommencer",
        thinking: "Je réfléchis à ce que tu m'as dit…", thanks: "Merci de m'avoir parlé", thanksName: "Merci de m'avoir parlé, {{name}}",
        needAdult: "J'ai besoin d'un adulte", trustedIntro: "Tu peux en parler à un adulte de confiance :",
        notifyAdult: "Prévenir un adulte", confirmQ: "Veux-tu prévenir un adulte ?",
        confirmSub: "Rien n'est envoyé tout seul. C'est toi qui choisis à qui envoyer ton message.",
        yesPrepare: "Oui, préparer", notNow: "Pas maintenant", msgIntro: "Voici le message que tu peux envoyer :",
        sendMsg: "Envoyer", copy: "Copier", msgFooter: "Tu choisis toi-même à qui l'envoyer. Rien n'est envoyé sans toi.",
        tellAnother: "Raconter autre chose",
        noSR: "Ton navigateur ne permet pas de parler ici. Tu peux demander à un adulte.",
        micNotAllowed: "Le micro n'est pas autorisé. Demande à un adulte de l'activer.",
        sayMore: "Raconte-moi un peu plus, avec tes mots.", tooMuch: "Tu as déjà beaucoup parlé aujourd'hui. Reviens demain ou demande à un adulte.",
        copied: "Message copié. Tu peux le coller pour un adulte.", shareOk: "Choisis l'adulte à qui envoyer ton message." },
      teenVoice: { talkToMe: "Parle-moi", listening: "Je t'écoute… vas-y, sans filtre.",
        pressMic: "Balance ce qui s'est passé. Je t'écoute, sans juger.", listeningBadge: "● En écoute — appuie pour stopper",
        send: "Envoyer", retry: "Recommencer", thinking: "Je regarde ça…", received: "Reçu. On regarde ça ensemble.",
        rights: "Connaître mes droits", reply: "Savoir quoi répondre", again: "Reparler",
        noSR: "Ton navigateur ne gère pas la dictée vocale ici. Tu peux écrire à la place.",
        micNotAllowed: "Micro non autorisé. Active-le dans ton navigateur.",
        sayMore: "Dis-en un peu plus.", limit: "Tu as atteint ta limite du jour. Reviens demain ou passe à Premium." },
    },
  }},
  en: { translation: {
    brand: { home: "The brand's home", version: "BIZARRE AI · v1.0.0 (beta)", menu: "Menu" },
    common: {
      open: "Open", openLink: "Open", logout: "Log out", profile: "Profile",
      goPremium: "Go Premium", admin: "Admin", loading: "WORKING…",
    },
    nav: {
      home: "Home", citation: "Quote of the day", situation: "I'm going through something",
      reply: "Reply", analyze: "Analyze", create: "Create", debate: "Debate", coach: "Coach",
      afromap: "Afro Map", communitySpace: "Community Space", youth: "Youth Space",
      parents: "Parents Space", rights: "Your rights", letters: "Letters", news: "News",
      library: "Knowledge base", authors: "Authors & sources", bookshelf: "Library",
      professionals: "Professionals", community: "Community", ideas: "Ideas", whatsnew: "What's new",
      feedback: "Your feedback", history: "History", dashboard: "Dashboard", about: "The BIZARRE house",
      discover: "Discover", help: "Help", me: "Me", rightsShort: "Rights", profileShort: "Profile",
      resources: "Resources",
    },
    home: {
      heroTitle1: "You're under attack.", heroTitle2: "Respond better.",
      heroSub1: "Racist comments. Discrimination. Harassment. Injustice.",
      heroSub2: "Paste the message. BIZARRE AI does the rest.",
      placeholder: "Paste a comment, a message or a situation…",
      replyNow: "REPLY NOW", analyzeNow: "ANALYZE NOW",
      step1: "Paste", step2: "The AI replies", step3: "Copy & post",
      writing: "BIZARRE AI is writing your reply…",
      writingSub: "A factual, sourced and reasoned reply. Just a few seconds.",
      resetAnother: "↺ Analyze another comment",
      statsTitle: "BIZARRE AI in numbers", statReplies: "Replies generated",
      statAnalyses: "Analyses completed", statUsers: "Users",
      whatToDo: "What would you like to do?",
      actions: {
        repondre: { title: "Reply", desc: "A clear, reasoned response to any attack." },
        analyser: { title: "Analyze", desc: "Understand a situation and know what to do." },
        droits: { title: "Know my rights", desc: "Your remedies and ready-to-use letters." },
        bibliotheque: { title: "Library", desc: "Selected Afro-descendant books and authors." },
        creer: { title: "Create content", desc: "Hooks, scripts and ideas that land." },
        communaute: { title: "Community", desc: "Connect, support each other and share." },
      },
      exampleTitle: "A concrete example", exampleComment: "The comment",
      exampleReplyLabel: "BIZARRE AI reply", tryExample: "TRY THIS EXAMPLE",
      demoComment: "Go back to your country.",
      demoReply: "I am home, and citizenship is not measured by skin color. Your sentence is not an argument: it is a prejudice that the law (art. 33 of the 1881 Act) punishes as a racist insult.",
      soon: "Coming soon · BIZARRE AI Community",
      communityTitle1: "The first social network where the AI replies", communityTitle2: "for you",
      communityDesc: "From any post, one click will be enough: \"Reply with BIZARRE AI\" or \"Analyze with BIZARRE AI\". It's the platform's signature.",
      discoverCommunity: "Discover the community",
      signature: "Replies. Experts. Books. Tools.", signatureGold: "Finally together.",
      signatureSub: "A universe by Céleste Créations.",
      teaser: { profiles: "Profiles", posts: "Posts", comments: "Comments", follows: "Follows", groups: "Groups", messaging: "Messaging", notifications: "Notifications" },
    },
    child: {
      greetingNamed: "Hi {{name}}!", greeting: "Hi champion!",
      howAreYou: "How are you today?",
      namePlaceholder: "Write your first name (optional)",
      changeName: "Change my name", addName: "Add my name",
      whatToDo: "What do you want to do?",
      cards: { hurt: "Someone hurt me", said: "Someone said something to me", understand: "I want to understand", sorties: "Outings & activities" },
      tellMe: "Tell me", tellMeSub: "Press and talk, I'm listening.",
      needAdult: "I need a grown-up",
    },
    teen: {
      heroTitle: "We get you.\nWe equip you.\nNow it's your move.",
      heroSub: "Racism, harassment, discrimination: you're not alone.",
      talkToAI: "Talk to the AI", analyzeSituation: "Analyze a situation",
      punchline: "Your voice matters. Use it.", whatToDo: "What do you want to do?",
      cards: {
        reply: { title: "Reply", desc: "Find the right words." },
        analyze: { title: "Analyze", desc: "Understand what's going on." },
        rights: { title: "Know my rights", desc: "Your rights, your options." },
        create: { title: "Create content", desc: "Hooks, posts, arguments." },
        library: { title: "Library", desc: "Books, podcasts, videos." },
      },
    },
    parent: {
      welcome: "Welcome, parent.",
      welcomeSub: "You're not alone in protecting and guiding your child.",
      talkToAI: "Talk to the AI", childSituation: "My child's situation",
      whatToDo: "What would you like to do?",
      cards: {
        understand: { title: "Understand the situation", desc: "Analyze what your child is experiencing." },
        rights: { title: "Know their rights", desc: "Your child's rights and your remedies." },
        act: { title: "Act and get guidance", desc: "The steps to take and who to contact." },
        resources: { title: "Resources for parents", desc: "Advice, guides and support." },
        sorties: { title: "Children's outings & activities", desc: "Map of Afro & cultural activities." },
      },
      guidesTitle: "Practical guides",
      guides: {
        listen: { title: "Knowing how to listen to my child", points: [
          "Choose a calm moment and let your child tell the story at their own pace, without interrupting.",
          "Welcome their emotions: \"I believe you, thank you for telling me. None of this is your fault.\"",
          "Avoid minimizing (\"it's nothing\") or over-reacting: stay calm and reassuring.",
          "Ask open questions: what happened, when, who was there, how do you feel?",
          "Remind them they can always come back and talk to you, and that they are not alone.",
        ]},
        proof: { title: "Keeping and collecting evidence", points: [
          "Write down the facts: dates, times, places, people present and exact words said.",
          "Take screenshots of messages, comments or posts (with the date visible).",
          "Keep useful documents: notes, letters, medical certificates, witness statements.",
          "Keep a copy in a safe place and file everything in chronological order.",
          "This evidence will help for a report to the school, a complaint or legal support.",
        ]},
        steps: { title: "The steps to take depending on the situation", points: [
          "At school (bullying, discrimination): request a written appointment with the teacher, the head of discipline or the management, and keep a record of exchanges.",
          "If nothing changes: write to the head of the establishment, then to the education authority.",
          "Racism / discrimination: you can contact the Defender of Rights (free) and a specialized association.",
          "In case of an offence (threats, violence, racist remarks): a complaint can be filed at the police station or by letter to the prosecutor.",
          "For support: a lawyer, an association or a professional can guide you. This information is general and does not replace personalized legal advice.",
        ]},
      },
      recoTitle: "Our recommendations to support you",
      steps: {
        s1: { title: "Listen and reassure", desc: "Your child needs to feel safe." },
        s2: { title: "Collect evidence", desc: "Messages, dates, witnesses…" },
        s3: { title: "Talk or report", desc: "Speak to those in charge or report it." },
        s4: { title: "Get support", desc: "Associations, mediators, legal help." },
      },
    },
    privacy: {
      default: "Your writing is private: visible only to you, on your account. Other users cannot see it.",
      kids: "You can look at the outings. To sign up or book, ask a grown-up: nothing happens without a parent.",
    },
    confidential: {
      badge: "Confidential private beta", title: "Access reserved for beta testers",
      body: "This version of BIZARRE AI is confidential and reserved for invited people. Please do not publicly share its content, screenshots or features before the official launch. Your feedback is precious — use the \"Report a problem\" button.",
      ack: "Got it, I'll keep this confidential",
    },
    kids: {
      title: "Outings & activities", subtitle: "Discover activities near you 🎨🥁📚",
      filters: { all: "All", today: "Today", weekend: "This weekend", wednesday: "Wednesday", vacances: "Holidays", free: "Free" },
      terr: { metropole: "🇫🇷 Mainland France", guadeloupe: "🌴 Guadeloupe", martinique: "🌺 Martinique" },
      allCats: "All categories", allRegions: "All regions",
      map: "Map", list: "List", free: "Free", paid: "Paid",
      years: "yrs", noResults: "No outing for this filter. Come back soon!",
      listen: "Listen", stop: "Stop", wantToGo: "I want to go!",
      safety: "This outing must be organized with a grown-up. Ask a parent.",
      wishSent: "✨ Great! I'm sending your request to your parent.",
      wishNoParent: "Ask a grown-up to link their account to yours so you can send your wish 💛",
      wishError: "Oops, try again in a moment.", audioUnavailable: "Audio is not available here.",
    },
    pages: {
      reply: { eyebrow: "Comeback", title: "Reply to a comment",
        subtitle: "Paste or scan a comment; the AI generates a short reply, a developed one, several styles and, when the topic calls for it, sources and a confidence level.",
        yourComment: "Your comment", closeScan: "Close scan", scanImage: "Scan an image",
        scanHint: "Upload a screenshot or take a photo of the comment.",
        addImage: "Add an image", analyzing: "Analyzing...", takePhoto: "Take a photo", chooseGallery: "Choose from gallery",
        placeholder: "E.g. \"Go back to your country.\"", placeholderChild: "E.g. \"Your hair looks weird.\"",
        generate: "Generate replies", spinnerScan: "Detecting text...", spinnerGen: "Generating...", textDetected: "Text detected!" },
      analyze: { eyebrow: "Analysis", title: "Analyze a situation",
        subtitle: "Tell us what happened. The AI offers a nuanced analysis, without automatic conclusions.",
        placeholder: "E.g. \"My colleague told me in front of everyone that…\"",
        placeholderChild: "E.g. \"A classmate made fun of my skin in front of everyone.\"",
        analyze: "Analyze", spinner: "Analyzing...",
        sec_interpretations: "Possible interpretations", sec_calm: "Respond calmly",
        sec_doc: "Document the facts", sec_resources: "Useful resources",
        premiumHint: "Premium unlocks far more analyses and the full history." },
      rights: { eyebrow: "Your rights", title: "Know your rights",
        subtitle: "Understand your rights simply. Clear fact sheets, an assistant, and AI that explains the law in plain language.",
        disclaimer: "General legal information, which does not replace a lawyer's advice.",
        victimCta: "I think I'm a victim of discrimination",
        victimSub: "Choose your situation and get the laws, rights, steps and deadlines.",
        smartSearch: "Smart search",
        searchPlaceholder: "E.g. \"My employer discriminates against me\", \"I received racist insults\"…",
        find: "Find", noMatch: "No sheet matches. Try the assistant below.",
        situationTitle: "Does my situation apply?",
        situationDesc: "Describe what's happening to you. The AI tells you which rights may be concerned and the possible steps.",
        situationPlaceholder: "E.g. \"A bar refused to let me in while my friends got through…\"",
        analyzeMy: "Analyze my situation", spinner: "Analyzing...", seeSheet: "See the sheet:",
        sec_rules: "Potentially applicable rules", sec_rights: "Rights concerned",
        sec_evidence: "Evidence to keep", sec_steps: "Possible steps", sec_orgs: "Who to contact",
        loadingSheets: "Loading sheets..." },
      letters: { back: "My letters", resultEyebrow: "Letter", resultTitle: "Review and adjust", recipientPrefix: "Recipient: ",
        objet: "Subject", corps: "Body of the letter", copy: "Copy", save: "Save", pdf: "Download PDF",
        copied: "Text copied.", saved: "Letter saved.", pdfError: "Download failed.",
        senderWarn1: "Add your contact details in ", senderWarnLink: "your profile", senderWarn2: " so they appear automatically in the PDF (name, address, signature).",
        advPreuves: "Evidence to keep", advEtapes: "Next steps", advOrgs: "Who to contact",
        formEyebrow: "New letter", formTitle: "Describe your situation", formSub: "Answer simply, in your own words. BIZARRE AI writes the letter for you.",
        toWhom: "Who are you writing to?", chooseRecipient: "— Choose a recipient —", orCustom: "… or type freely (e.g. Head of Human Resources)",
        letterType: "Type of letter", optional: "— Optional —", tone: "Tone of the letter",
        generate: "Generate my letter", generating: "Writing…", spinnerGen: "BIZARRE AI is writing your letter…",
        needSituation: "Describe your situation first.", duplicated: "Letter duplicated.", removed: "Deleted.", confirmRemove: "Delete this letter?",
        listEyebrow: "Letters assistant", listTitle: "Letter generator",
        listSub: "Describe your situation, the AI writes a clear, professional letter. Editable and downloadable as PDF.",
        newLetter: "New letter", empty: "No letters yet. Create your first letter in a few minutes.",
        open: "Open", duplicate: "Duplicate", remove: "Delete", loading: "Loading..." },
      books: { eyebrow: "Library", title: "The BIZARRE showcase",
        subtitle: "Books, authors and Afro-descendant memory — a living library, regularly enriched.",
        all: "All", partnerAuthor: "Partner author", recommended: "Recommended", nouveautes: "📚 New arrivals",
        emptyCat: "New books will be added soon in \"{{cat}}\".",
        empty: "New books will be added soon.", loading: "Loading..." },
      childVoice: { tellMe: "Tell me", tellMeName: "Tell me, {{name}}",
        listening: "I'm listening… use your own words.", pressMic: "Press the mic and say what happened.",
        listeningBadge: "● Listening — press to stop", send: "OK, send it", retry: "Start over",
        thinking: "I'm thinking about what you told me…", thanks: "Thank you for talking to me", thanksName: "Thank you for talking to me, {{name}}",
        needAdult: "I need a grown-up", trustedIntro: "You can talk about it to a trusted grown-up:",
        notifyAdult: "Tell a grown-up", confirmQ: "Do you want to tell a grown-up?",
        confirmSub: "Nothing is sent on its own. You choose who to send your message to.",
        yesPrepare: "Yes, prepare it", notNow: "Not now", msgIntro: "Here is the message you can send:",
        sendMsg: "Send", copy: "Copy", msgFooter: "You choose yourself who to send it to. Nothing is sent without you.",
        tellAnother: "Tell me something else",
        noSR: "Your browser can't let you speak here. You can ask a grown-up.",
        micNotAllowed: "The mic isn't allowed. Ask a grown-up to turn it on.",
        sayMore: "Tell me a bit more, in your own words.", tooMuch: "You've talked a lot today. Come back tomorrow or ask a grown-up.",
        copied: "Message copied. You can paste it for a grown-up.", shareOk: "Choose the grown-up to send your message to." },
      teenVoice: { talkToMe: "Talk to me", listening: "I'm listening… go ahead, no filter.",
        pressMic: "Drop what happened. I'm listening, no judgment.", listeningBadge: "● Listening — press to stop",
        send: "Send", retry: "Start over", thinking: "Let me look at this…", received: "Got it. Let's look at this together.",
        rights: "Know my rights", reply: "Know what to reply", again: "Talk again",
        noSR: "Your browser doesn't support voice input here. You can type instead.",
        micNotAllowed: "Mic not allowed. Enable it in your browser.",
        sayMore: "Tell me a bit more.", limit: "You've reached your daily limit. Come back tomorrow or go Premium." },
    },
  }},
};

i18n.use(initReactI18next).init({
  resources,
  lng: stored === "en" ? "en" : "fr",
  fallbackLng: "fr",
  interpolation: { escapeValue: false },
});

export default i18n;
